// src/components/video/PresentationLayout.tsx
import React, { useState, useEffect, useRef, CSSProperties } from "react";
import { ParticipantTile } from "./ParticipantTile";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import VideoChatHeader from "./controls/VideoChatHeader";
import { ShareScreenIcon } from "../SvgIcons/ShareScreenIcon";

interface Participant {
  feedId: string;
  displayName?: string;
  stream: MediaStream | null;
  isMuted: boolean;
  isCameraOn: boolean;
  isLocal?: boolean;
}

interface ScreenShareFeed {
  feedId: string;
  stream: MediaStream | null;
}

interface PresentationLayoutProps {
  participants: Participant[];
  screenShareFeed: ScreenShareFeed;
  screenSharerDisplayName: string;
  showParticipantGrid?: boolean;
}

export const PresentationLayout: React.FC<PresentationLayoutProps> = ({
  participants,
  screenShareFeed,
  screenSharerDisplayName,
  showParticipantGrid = true,
}) => {
  const screenShareVideoRef = React.useRef<HTMLVideoElement>(null);
  const thumbnailContainerRef = useRef<HTMLDivElement>(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(1);

  useEffect(() => {
    const calculatePageSize = () => {
      if (thumbnailContainerRef.current) {
        const containerWidth = thumbnailContainerRef.current.offsetWidth;
        const tileWidth = 180; // width of a thumbnail
        const gap = 8; // gap-2 is 0.5rem -> 8px
        const newPageSize = Math.floor(containerWidth / (tileWidth + gap));
        setPageSize(Math.max(1, newPageSize));
      }
    };

    calculatePageSize();
    window.addEventListener('resize', calculatePageSize);
    return () => window.removeEventListener('resize', calculatePageSize);
  }, []);

  useEffect(() => {
    if (screenShareVideoRef.current && screenShareFeed.stream) {
      screenShareVideoRef.current.srcObject = screenShareFeed.stream;
    }
  }, [screenShareFeed.stream]);

  const thumbnailParticipants = participants.filter(
    (p) => p.feedId !== screenShareFeed.feedId
  );

  const totalParticipants = thumbnailParticipants.length;
  const totalPages = pageSize > 0 ? Math.ceil(totalParticipants / pageSize) : 0;

  useEffect(() => {
    if (currentPage >= totalPages) {
      setCurrentPage(Math.max(0, totalPages - 1));
    }
  }, [totalPages, currentPage]);

  let paginatedThumbnails;
  const isLastPage = currentPage === totalPages - 1;

  if (isLastPage && totalParticipants > pageSize && (totalParticipants % pageSize !== 0)) {
    paginatedThumbnails = thumbnailParticipants.slice(totalParticipants - pageSize);
  } else {
    paginatedThumbnails = thumbnailParticipants.slice(
      currentPage * pageSize,
      (currentPage + 1) * pageSize
    );
  }

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
  };

  console.log('Participants!', participants);
  console.log("thumbnail participants" , thumbnailParticipants);

  /////////////////////////////////
  /*  Grid Layout Responsive Styling */
  /////////////////////////////////
  const styledData : CSSProperties = showParticipantGrid ? {
    width: "25%",
    transform : "translateX(0%)",
    visibility: "visible",
  } : {
    width: "0%",
    transform : "translateX(100%)",
    visibility: "hidden",
  }

  return (
    <div className="h-full w-full px-4 pt-2">
      {/* {thumbnailParticipants.length > 0 && (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ flex: "0 0 auto" }}
        >
          {totalPages > 1 && (
            <button
              onClick={handlePrevPage}
              disabled={currentPage === 0}
              className="btn btn-dark btn-sm me-2"
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
          )}
          <div ref={thumbnailContainerRef} className="flex-grow-1" style={{ overflow: 'hidden' }}>
            <div className="d-flex flex-nowrap justify-content-center gap-2"> */}
              {/* {paginatedThumbnails.map((participant) => (
                <div>
                  {(participant.displayName) && (
                    <div
                      key={participant.feedId}
                      style={{ width: "180px", flexShrink: 0 }}
                    >
                      <ParticipantTile participant={participant} isSharing={true} size="xs" />
                    </div>
                  )}
                </div>
              ))} */}
            {/* </div>
          </div>
          {totalPages > 1 && (
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages - 1}
              className="btn btn-dark btn-sm ms-2"
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          )}
        </div>
      )} */}

      <div className="w-full h-full flex gap-2">
            <div className="h-full"
              style={{
                width : showParticipantGrid ? "75%" : "100%"
              }}
            >
              <div className="w-full h-full bg-[#B1B1B1] relative rounded-lg">
                <div className="w-full h-full flex justify-center items-center">
                  <div className="flex flex-col justify-center items-center gap-[0.5rem]">
                    <ShareScreenIcon size={100}/>
                    <h4 className="text-white">You are sharing your screen</h4>
                    <p className="text-white">Participants can see your screen</p>
                  </div>
                </div>
                <div className="w-full h-full">
                  <video
                    ref={screenShareVideoRef}
                    className="rounded-3 position-absolute top-50 start-50 w-full h-full"
                    style={{
                      objectFit: "cover",
                      maxWidth: "100%",
                      maxHeight: "100%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1
                    }}
                    autoPlay
                    playsInline
                  /> 
                </div>

                {/* sharing screen badge */}
                <div className="absolute top-4 left-4 z-10 flex items-center gap-[0.5rem] bg-black px-[0.875rem] py-[0.325rem] rounded-lg">
                  <div className="w-2 h-2 rounded-full bg-[#FB2C36]"></div>
                  <div className="">
                    <span>Sharing Screen</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-full transition-all duration-300"
              style={{
                ...styledData
              }}
            >
                  {
                    thumbnailParticipants && thumbnailParticipants?.length > 0 ? (
                      <div>
                        {
                          thumbnailParticipants?.map((participant , index) => {
                            return (
                              <div key={participant?.feedId || index} className="px-[0.345rem] mb-[0.5rem]">
                                <ParticipantTile participant={participant} isSharing={true} size={"xs"}/>
                              </div>
                            )
                          })
                        }
                      </div>
                    ) : (
                      <div className="w-full h-full flex justify-center items-center">
                        <div className="">
                          <p className="m-0 text-[#B1B1B1] text-[1rem]">No participants found</p>
                        </div>
                      </div>
                    )
                  }
            </div>
      </div>

    </div>
  );
};
